import React, { useContext, useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../teacherStore";
import { getStudentAnswersByQuestion } from "../../../../libs/ActiveLearning";
import TreeCard from "../../../../atoms/ActiveLearning/TreeCard";
import styles from "../ActiveLearningLessonAnswerData.module.scss";

interface ILesson8Pros {
  materialCode: string;
  lessonNo: number;
}

export const Lesson8: React.FC<ILesson8Pros> = ({ materialCode, lessonNo }) => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;

  const answersL8I1Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      1,
    );
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL5I2Q6 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      materialCode === "ECS001" ? 5 : 6,
      2,
      6,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers]);

  const answersL8I2Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      2,
      1,
    );
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo}{" "}
        行動の中で見つけた気づきを活かそう
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <div className={styles.question}>
            <p className={styles.heading}>行動した結果を振り返ろう。</p>
            <div className={styles.multiple}>
              <div className={styles.block}>
                <p className={styles.label}>わかったこと</p>
                {answersL8I1Q1.length > 0 ? (
                  answersL8I1Q1.map(answer => (
                    <p
                      key={answer.id}
                      className={clsx(styles.answer, styles.high)}
                    >
                      {answer.contents.good}
                    </p>
                  ))
                ) : (
                  <p className={clsx(styles.answer, styles.high)}>
                    回答データがありません。
                  </p>
                )}
              </div>
              <div className={styles.block}>
                <p className={styles.label}>改善点</p>
                {answersL8I1Q1.length > 0 ? (
                  answersL8I1Q1.map(answer => (
                    <p
                      key={answer.id}
                      className={clsx(styles.answer, styles.high)}
                    >
                      {answer.contents.motto}
                    </p>
                  ))
                ) : (
                  <p className={clsx(styles.answer, styles.high)}>
                    回答データがありません。
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              ステップを調整して、より実現性の高いステップを導き出そう。
            </p>
            <div className={styles.tree}>
              <TreeCard
                title={"実現したいと思う解決のアイデア"}
                text={answersL5I2Q6}
              />
              <ul className={styles.branchList}>
                {answersL8I2Q1.length > 0 ? (
                  answersL8I2Q1.reverse().map(answer => (
                    <li key={answer.id} className={styles.branch}>
                      <div className={styles.labelWrapper}>
                        <span className={styles.label}>
                          ステップ{answer.contents.stepNo}
                        </span>
                      </div>
                      <p className={styles.answer}>{answer.contents.value}</p>
                    </li>
                  ))
                ) : (
                  <li className={styles.branch}>
                    <div className={styles.labelWrapper}>
                      <span className={styles.label}>ステップ</span>
                    </div>
                    <p className={styles.answer}>回答データがありません。</p>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson8;
